module.exports = __webpack_public_path__ + "static/brush-yellow-spark-right-7f3b8b46b559b78190506075c6da47f8.png";